export default function addParameterHelper(url, parameterString) {
    if(url.includes('?')) {
        url += '&';
    }
    else {
        url += '?';
    }

    return url + parameterString;
}